import React from "react";
import "./PreNavbar.css";

const PreNavbar = () => {
  return (
    <div className="prenavbar-container">
      <div className="prenavbar-content">
        <div className="prenavbar-item">
          <i className="fab fa-whatsapp"></i>
          <span>24/7 Services Available</span>
          <strong>+91 98400 88046</strong>
        </div>

        <div className="prenavbar-item">
          <i className="fas fa-shield-alt regno"></i>
          <span>Govt. Reg No</span>
          <strong>1869/2016</strong>
        </div>

        <div className="prenavbar-item">
          <i className="fas fa-file-invoice regno"></i>
          <span>GST No:</span>
          <strong>33AIZPT7902P1Z5</strong>
        </div>

        <div className="prenavbar-item">
          <i className="fas fa-file-invoice regno"></i>
          <span>RCS No:</span>
          <strong> QT-96932/0725</strong>
        </div>
      </div>
    </div>
  );
};

export default PreNavbar;
